import { DataSource, HorizontalSpacer, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMacroPointDataExportControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    macroPointSwitchActive: Switch;
    sourceMacropointControl: DataSource;
    switchSendTemperature: Switch;
    textboxEmail: Textbox;
    textboxEventsSent: Textbox;
    textboxMacroPointId: Textbox;
    textboxMacroPointPassword: Textbox;
    textboxPositionsInterval: Textbox;
    textboxPositionsSent: Textbox;
    textboxRequestorID: Textbox;
    textboxURL: Textbox;
}
